var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYolospyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.6078,
    y1: 881.2156,
    x2: 440.6078,
    y2: -9.094947e-13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#203C78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#135E40"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.2,525.9c-0.9-9.2-4.8-16.3-11.7-21.4c-6.9-5.1-16.2-7.6-28.1-7.6c-8,0-14.8,1.1-20.3,3.4 c-5.5,2.2-9.8,5.3-12.7,9.3c-2.9,3.9-4.4,8.4-4.4,13.4c-0.2,4.2,0.7,7.8,2.7,10.9c1.9,3.1,4.6,5.8,8,8c3.4,2.2,7.3,4.2,11.8,5.8 c4.5,1.6,9.2,3,14.3,4.1l20.9,5c10.2,2.3,19.5,5.3,28,9.1c8.5,3.8,15.8,8.4,22,14c6.2,5.5,11,12,14.5,19.5 c3.4,7.5,5.2,16.1,5.3,25.8c-0.1,14.2-3.7,26.6-10.9,37c-7.2,10.4-17.5,18.5-30.9,24.2c-13.4,5.7-29.6,8.6-48.6,8.6 c-18.8,0-35.1-2.9-49-8.6c-13.9-5.8-24.7-14.3-32.5-25.6c-7.8-11.3-11.8-25.4-12.2-42.1h47.6c0.5,7.8,2.8,14.3,6.8,19.5 c4,5.2,9.3,9.1,16,11.7s14.3,3.9,22.8,3.9c8.3,0,15.6-1.2,21.8-3.6c6.2-2.4,11-5.8,14.4-10.1c3.4-4.3,5.1-9.3,5.1-14.9 c0-5.2-1.5-9.6-4.6-13.2c-3.1-3.6-7.5-6.6-13.4-9.1c-5.9-2.5-13-4.8-21.5-6.8l-25.3-6.4c-19.6-4.8-35.1-12.2-46.5-22.4 c-11.4-10.2-17-23.8-16.9-41c-0.1-14.1,3.7-26.4,11.3-36.9c7.6-10.5,18.1-18.8,31.4-24.7c13.3-5.9,28.5-8.9,45.5-8.9 c17.3,0,32.4,3,45.3,8.9c12.9,5.9,23,14.1,30.2,24.7c7.2,10.5,10.9,22.7,11.1,36.6H278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,691.7V459h91.8c17.7,0,32.7,3.4,45.1,10.1c12.4,6.7,21.9,16,28.5,27.8c6.6,11.9,9.8,25.5,9.8,41 c0,15.5-3.3,29.1-10,40.9c-6.7,11.8-16.3,21-28.9,27.6s-27.9,9.9-45.7,9.9H382v-39.4h50.6c9.5,0,17.3-1.6,23.5-4.9 c6.2-3.3,10.8-7.9,13.9-13.8c3.1-5.9,4.6-12.6,4.6-20.3c0-7.7-1.5-14.5-4.6-20.3c-3.1-5.8-7.7-10.3-13.9-13.5 c-6.2-3.2-14.1-4.8-23.6-4.8h-33.2v192.5H350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.1,459h55.1l53.1,100.2h2.3L695.6,459h55.1l-84.9,150.5v82.3H617v-82.3L532.1,459z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.4,234.7h46.2l44.5,84h1.9l44.5-84h46.2l-71.1,126.1v69h-41v-69L98.4,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,332.2c0,21.3-4,39.4-12,54.3c-8,14.9-19,26.3-32.8,34.1c-13.8,7.8-29.3,11.8-46.5,11.8 c-17.3,0-32.9-3.9-46.7-11.8c-13.8-7.9-24.7-19.3-32.7-34.2c-8-14.9-12-33-12-54.2c0-21.3,4-39.4,12-54.3 c8-14.9,18.9-26.3,32.7-34.1c13.8-7.8,29.3-11.8,46.7-11.8c17.2,0,32.7,3.9,46.5,11.8c13.8,7.8,24.7,19.2,32.8,34.1 C457.8,292.9,461.8,310.9,461.8,332.2z M420,332.2c0-13.8-2-25.4-6.1-34.9c-4.1-9.5-9.9-16.6-17.3-21.5 c-7.4-4.9-16.1-7.3-26.1-7.3c-10,0-18.7,2.4-26.1,7.3c-7.4,4.9-13.2,12.1-17.3,21.5c-4.1,9.5-6.1,21.1-6.1,34.9 c0,13.8,2,25.4,6.1,34.9c4.1,9.5,9.9,16.6,17.3,21.5c7.4,4.9,16.1,7.3,26.1,7.3c10,0,18.7-2.4,26.1-7.3 c7.4-4.9,13.2-12.1,17.3-21.5C418,357.6,420,346,420,332.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M482.6,429.7v-195h41.2v161h83.6v34H482.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M796.8,332.2c0,21.3-4,39.4-12,54.3c-8,14.9-19,26.3-32.8,34.1c-13.8,7.8-29.3,11.8-46.5,11.8 c-17.3,0-32.9-3.9-46.7-11.8c-13.8-7.9-24.7-19.3-32.7-34.2c-8-14.9-12-33-12-54.2c0-21.3,4-39.4,12-54.3 c8-14.9,18.9-26.3,32.7-34.1c13.8-7.8,29.3-11.8,46.7-11.8c17.2,0,32.7,3.9,46.5,11.8c13.8,7.8,24.7,19.2,32.8,34.1 C792.8,292.9,796.8,310.9,796.8,332.2z M755,332.2c0-13.8-2-25.4-6.1-34.9c-4.1-9.5-9.9-16.6-17.3-21.5 c-7.4-4.9-16.1-7.3-26.1-7.3c-10,0-18.7,2.4-26.1,7.3c-7.4,4.9-13.2,12.1-17.3,21.5c-4.1,9.5-6.1,21.1-6.1,34.9 c0,13.8,2,25.4,6.1,34.9c4.1,9.5,9.9,16.6,17.3,21.5c7.4,4.9,16.1,7.3,26.1,7.3c10,0,18.7-2.4,26.1-7.3 c7.4-4.9,13.2-12.1,17.3-21.5C752.9,357.6,755,346,755,332.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolospyIcon);
export default __webpack_public_path__ + "static/media/yolospy_icon.3dc9a4172afe40620093285ea39930d3.svg";
export { ForwardRef as ReactComponent };